// extracted by mini-css-extract-plugin
export default {"main":"Button_main__PRLPk"};